// 埋点专用的请求
import axios from 'axios';

const $axios = axios.create({
  // todo：需要修改成线上
  baseURL: (window.location.href.indexOf("testhyt") > -1 || (window.location.href.indexOf("http://localhost/") > -1)) ? 'https://jdtest.yucrm.cn' : 'https://jd.yucrm.cn'
})

/**
 * postJson方法，对应post请求
 * body请求体
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function bpPostJson(url, params) {
  $axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
  return new Promise((resolve, reject) => {
    $axios.post(url, params)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data)
      })
  });
}